// extracted by mini-css-extract-plugin
module.exports = {"radioInputBox":"RadioInput-module--radioInputBox--2z2Py","inputBox":"RadioInput-module--inputBox--1vO__"};